import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const navBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textColor = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-800';

  const linkColor = isHome && !scrolled
    ? 'text-white/90 hover:text-white'
    : 'text-foreground-700 hover:text-primary-500';

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${navBg} ${scrolled ? 'shadow-sm' : ''}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`font-heading text-2xl whitespace-nowrap ${textColor}`}>
            愽彩糖果
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              首页
            </Link>

            <div className="relative"
              onMouseEnter={() => setCategoryOpen(true)}
              onMouseLeave={() => setCategoryOpen(false)}
            >
              <Link
                to="/category/fruit-candy"
                className={`text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 ${linkColor}`}
              >
                糖果分类
                <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 bg-background-50 rounded-lg shadow-lg border border-background-200 py-2 min-w-[180px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/articles" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              糖果资讯
            </Link>

            <Link to="/about" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center ${textColor}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 pb-4">
            <Link to="/" className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100">
              首页
            </Link>
            <div className="px-4 py-2 text-sm font-medium text-foreground-500">糖果分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="block px-8 py-2 text-sm text-foreground-600 hover:bg-background-100"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/articles" className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100">
              糖果资讯
            </Link>
            <Link to="/about" className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100">
              关于我们
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}